export enum FirmwareState {
  IDLE = 'Idle', // Firmware update waiting for start
  STARTING = 'Starting', // BLE Manager starting
  SCANNING = 'Scanning', // BLE Manager is scanning for bluetooth devices
  PREPARING = 'Preparing', // BLE Manager is preparing to get in firmware mode
  PROCESSING = 'Processing', // BLE Manager is perparing for firmware update
  UPLOADING = 'Uploading', // BLE Manager is uploading firmware
  UPDATING = 'Updating', // BLE Manager is updating firmware
  COMPLETED = 'Completed', // Firmware update completed
  FAILED = 'Failed', // Firmware update has failed.
}
